import { useSelector } from "react-redux";
import { ILocalState } from "../../@types/index.d";
import {
  ClientInput,
  ELegalForms,
  FileUploadVariant,
  IArrangementKeys,
  IArrangementKeysV1,
  IArrangementKeysV2,
  IArrangementKeysV3,
  IArrangementKeysV4,
  IUploadSettings,
} from "@canei/app-components";
import { useMemo } from "react";

export const initialMappingFromVariant = (variant: FileUploadVariant): IArrangementKeys => {
  const v1: IArrangementKeysV1 = {
    account_code: "",
    description: "",
    starting_balance: "",
    starting_balance_h: "",
    starting_balance_s: "",
    balance: "",
    balance_h: "",
    balance_s: "",
  };
  const v2: IArrangementKeysV2 = {
    account_code: "",
    description: "",
    starting_balance: "",
    starting_balance_sh: "",
    balance: "",
    balance_sh: "",
  };
  const v3: IArrangementKeysV3 = {
    account_code: "",
    description: "",
    starting_balance_h: "",
    starting_balance_s: "",
    balance_h: "",
    balance_s: "",
  };
  const v4: IArrangementKeysV4 = {
    account_code: "",
    description: "",
    starting_balance: "",
    balance: "",
  };

  switch (variant) {
    case FileUploadVariant.V1:
      return v1;
    case FileUploadVariant.V2:
      return v2;
    case FileUploadVariant.V3:
      return v3;
    case FileUploadVariant.V4:
      return v4;
    default:
      throw Error(`${variant} variant can not be other than v1,v2,v3,v4`);
  }
};
export const reMapUploadPreferences = ({
  variant_type,
  sheet_name,
  format,
  quote,
  delimiter,
  ...rest
}: IUploadSettings): IUploadSettings | undefined => {
  if (variant_type && format) {
    const mapping = initialMappingFromVariant(variant_type);
    const mappedMapping: Record<string, string> = {};
    const preferencesMap = new Map(Object.entries(rest));

    Object.keys(mapping).forEach((key: string) => {
      const val = preferencesMap.get("mapping");

      if (val) {
        mappedMapping[key] = val[key as keyof IArrangementKeys] || "";
      }
    });
    const newMapping = mappedMapping as unknown as IArrangementKeys;

    return {
      variant_type,
      format,
      sheet_name,
      quote,
      delimiter,
      mapping: newMapping,
    };
  }
  return undefined;
};
export const useSelectedClientData = (): ClientInput | false => {
  const currentUser = useSelector(({ currentUser }: ILocalState) => currentUser);
  const client = useMemo(
    () =>
      currentUser.clients.find(
        ({ client_id }) => client_id === currentUser.selectedClient.client_id
      ),
    [currentUser.clients, currentUser.selectedClient.client_id]
  );

  if (!client) return false;
  if (!client.mapping) return false;
  // I commented next line which is unnecessary for the registration but necessary for the setupflow
  // if (!client.legal_form) return false;
  const uploadSettings = currentUser?.selectedClient?.metaData?.conversion || undefined;
  const uploadPreferences = uploadSettings ? reMapUploadPreferences(uploadSettings) : undefined;
  return {
    ...client,
    mapping: client.mapping, // explicitly defined to avoid TS-linter error.(although unnecessary)
    legal_form: client.legal_form as ELegalForms,
    customer_id: currentUser.appUser.customer_id,
    customization: {
      ...client.customization,
      upload_settings: uploadPreferences,
    },
    links: client.links,
  };
};
